import { Action } from '@ngrx/store';
import { IShipmentLocationRequest } from '@cemex-core/cmx-api/models/shipment-location/shipment-location-request';
import { IShipmentLocationResponse } from '@cemex-core/cmx-api/models/shipment-location/shipment-location-response';
import { IShipmentLocation } from '@cemex-core/cmx-api/models/shipment-location/shipment-location';
import { IAddressResponse } from '@cemex-core/cmx-api/models/addresses-req-management/addresses-response';
import { IJobsiteSalesArea } from '@cemex-core/cmx-api/models/jobsite-sales-areas/jobsite-sales-area';
import { ContactsTypesTypes } from '../../../../../shared/constants/contacts-types';
import { IContactResponse } from '@cemex-core/cmx-api/models/contact/contact-response.interface';
import { ILocationConfigUnit } from '../../models/location-config.interface';
import { Plant } from '@cemex-core/cmx-api/models/order-management/plant';
import { StdLotSizeReq } from '@cemex-core/cmx-api/models/std-lot-size';
import { MultipleStdLotSizeRes } from '@cemex-core/cmx-api/models/std-lot-size/multiple-std-lot-size-res';
import { Link, FullSalesArea } from '@cemex-core/cmx-api';

export interface IGeoCoordinates {
  latitude: number;
  longitude: number;
}

export const LOAD_INITIAL_STATE = '[Jobsite] Load initial state';
export const RESET = '[Jobsite] Reset state';
export const LOAD = '[Jobsite] Load';
export const LOAD_NO_SHIPPING_CONDITION = '[Jobsite] Load without Shippiing Condition';
export const LOAD_NO_DOCUMENTS = '[Jobsite] Load without documents';
export const LOAD_COMPLETE = '[Jobsite] Load Complete';
export const LOAD_FAIL = '[Jobsite] Load Fail';
export const JOBSITE_SET = '[Jobsite] Set';

export const LOAD_ADDRESS = '[Jobsite] Load address';
export const LOAD_ADDRESS_SUCCESS = '[Jobsite] Load address success';
export const LOAD_ADDRESS_FAIL = '[Jobsite] Load address fail';
export const PATCH_ADDRESS_COORDINATES = '[Jobsite] Patch address coordinates';

export const LOAD_SALES_AREA = '[Jobsite] Load sales area';
export const LOAD_SALES_AREA_SUCCESS = '[Jobsite] Load sales area success';
export const LOAD_SALES_AREA_FAIL = '[Jobsite] Load sales area fail';
export const LOAD_FULL_SALES_AREA = '[Jobsite] Jobsite Load full sales area';
export const LOAD_FULL_SALES_AREA_SUCCESS = '[Jobsite] Jobsite Load full sales area success';
export const LOAD_FULL_SALES_AREA_FAIL = '[Jobsite] Jobsite Load full sales area fail';

export const LOAD_STD_LOT = '[Jobsite] Load std lot';
export const LOAD_STD_LOT_SUCCESS = '[Jobsite] Load std lot success';

export const LOAD_CONTACTS = '[Jobsite] Load contacts';
export const LOAD_CONTACTS_SUCCESS = '[Jobsite] Load contacts success';
export const LOAD_CONTACTS_FAIL = '[Jobsite] Load contacts fail';

export const LOAD_JOBSITE_PLANT = '[Jobsite] Load plant';
export const SET_JOBSITE_PLANT = '[Jobsite] Set plant';
export const LOAD_JOBSITE_PLANT_FAILED = '[Jobsite] Load plant failed';

export const JOBSITE_SET_AVAILABILITY = '[Jobsite] set availability';

export class JobsiteLoadInitialStateAction implements Action {
  readonly type = LOAD_INITIAL_STATE;

  constructor(public payload: ILocationConfigUnit) {}
}

export class JobsiteResetStateAction implements Action {
  readonly type = RESET;

  constructor(public payload = null) {}
}

export class JobsiteLoadAction implements Action {
  readonly type = LOAD;

  constructor(public payload: IShipmentLocationRequest) {}
}

export class JobsiteLoadNoShippingConditionAction implements Action {
  readonly type = LOAD_NO_SHIPPING_CONDITION;

  constructor(public payload: IShipmentLocationRequest) {}
}

export class JobsiteLoadNoDocumentsAction implements Action {
  readonly type = LOAD_NO_DOCUMENTS;

  constructor(public payload: IShipmentLocationRequest) {}
}

export class JobsiteLoadCompleteAction implements Action {
  readonly type = LOAD_COMPLETE;

  constructor(public payload: IShipmentLocationResponse) {}
}

export class JobsiteLoadFailAction implements Action {
  readonly type = LOAD_FAIL;

  // todo:: type of error handling
  constructor(public payload: any) {}
}

export class JobsiteSetAction implements Action {
  readonly type = JOBSITE_SET;

  constructor(public payload: IShipmentLocation) {}
}

export class LoadJobsiteAddress {
  readonly type = LOAD_ADDRESS;

  constructor(public payload: number) {}
}

export class LoadJobsiteAddressComplete {
  readonly type = LOAD_ADDRESS_SUCCESS;

  constructor(public payload: IAddressResponse) {}
}

export class LoadJobsiteAddressFail {
  readonly type = LOAD_ADDRESS_FAIL;

  // todo:: type of error handling
  constructor(public payload: any) {}
}

export class LoadJobsiteSalesArea {
  readonly type = LOAD_SALES_AREA;

  constructor(public payload: IShipmentLocation) {}
}

export class LoadJobsiteSalesAreaComplete {
  readonly type = LOAD_SALES_AREA_SUCCESS;

  constructor(public payload: IJobsiteSalesArea[]) {}
}

export class LoadJobsiteFullSalesArea {
  readonly type = LOAD_FULL_SALES_AREA;

  constructor(public payload: Link) {}
}

export class LoadJobsiteFullSalesAreaComplete {
  readonly type = LOAD_FULL_SALES_AREA_SUCCESS;

  constructor(public payload: FullSalesArea) {}
}

export class LoadJobsiteFullSalesAreaFail {
  readonly type = LOAD_FULL_SALES_AREA_FAIL;
  constructor(public payload: any) {}
}

export class LoadJobsiteStdLot {
  readonly type = LOAD_STD_LOT;

  constructor(public payload: StdLotSizeReq) {}
}

export class LoadJobsiteStdLotComplete {
  readonly type = LOAD_STD_LOT_SUCCESS;

  constructor(public payload: MultipleStdLotSizeRes) {}
}

export class LoadJobsiteSalesAreaFail {
  readonly type = LOAD_SALES_AREA_FAIL;

  // todo:: type of error handling
  constructor(public payload: any) {}
}

export class LoadJobsiteContacts {
  readonly type = LOAD_CONTACTS;

  constructor(public payload: ContactsTypesTypes) {}
}
export class LoadJobsitePlant {
  readonly type = LOAD_JOBSITE_PLANT;
}

export class SetJobsitePlant {
  readonly type = SET_JOBSITE_PLANT;

  constructor(public payload: Plant[]) {}
}

export class LoadJobsitePlantFail {
  readonly type = LOAD_JOBSITE_PLANT_FAILED;

  // todo:: type of error handling
  constructor(public payload: any) {}
}

export class LoadJobsiteContactsComplete {
  readonly type = LOAD_CONTACTS_SUCCESS;

  constructor(public payload: IContactResponse) {}
}

export class LoadJobsiteContactsFail {
  readonly type = LOAD_CONTACTS_FAIL;

  // todo:: type of error handling
  constructor(public payload: any) {}
}

export class JobsiteSetAvailabilityAction {
  readonly type = JOBSITE_SET_AVAILABILITY;

  constructor(public payload: boolean) {}
}

export class PatchJobsiteAddressCoordinates {
  readonly type = PATCH_ADDRESS_COORDINATES;

  constructor(public payload: IGeoCoordinates) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type JobsiteActions =
  | JobsiteLoadInitialStateAction
  | JobsiteResetStateAction
  | JobsiteLoadAction
  | JobsiteLoadNoShippingConditionAction
  | JobsiteLoadNoDocumentsAction
  | JobsiteLoadCompleteAction
  | JobsiteLoadFailAction
  | JobsiteSetAction
  | LoadJobsiteAddress
  | LoadJobsiteAddressComplete
  | LoadJobsiteAddressFail
  | LoadJobsiteSalesArea
  | LoadJobsiteSalesAreaComplete
  | LoadJobsiteSalesAreaFail
  | LoadJobsiteFullSalesArea
  | LoadJobsiteFullSalesAreaComplete
  | LoadJobsiteFullSalesAreaFail
  | LoadJobsiteStdLot
  | LoadJobsiteStdLotComplete
  | LoadJobsitePlant
  | SetJobsitePlant
  | LoadJobsitePlantFail
  | JobsiteSetAvailabilityAction
  | PatchJobsiteAddressCoordinates;
